import React from 'react'
import classNames from 'classnames'

export function Link({ children,  modifierClasses = [], ...props }) {
  const linkClasses = classNames(
    'link',
    'link--large',
    'u-font-weight-700',
    modifierClasses
  )
  return (
    <a
      {...props}
      className={linkClasses}
      onClick={() => {
        const scrollPosition = window.pageYOffset || 0
        history.pushState({ scrollPosition }, null, null)
      }}
    >
      {children}
    </a>
  )
}
